// extracted by mini-css-extract-plugin
export default {"shake":"zbcm4"};